<template>
    <div class="table-responsive" v-loading="isBusy">
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <th>Date</th>
                <th v-if="employerColsEnabled">Employer ID</th>
                <th v-if="employerColsEnabled">Employer</th>
                <th>Job ID</th>
                <th>Name</th>
                <th>Lead Type</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Zip Code</th>
                <th>State</th>
                <th>CDL XP</th>
                <th>CDL A<br>Months Driven</th>
                <th>JA Name</th>
                <th>JA Call Transfer</th>
                <th>Source</th>
                <th></th>
            </tr>
            </thead>

            <tbody>
                <tr v-if="data.length === 0">
                    <td :colspan="employerColsEnabled ? 14 : 12"
                        class="text-center"
                        style="font-weight:bold;padding:15px;color:#f00;">
                        No data
                    </td>
                </tr>
                <applications-table-row 
                    v-else
                    v-for="row in data" 
                    :key="row.id"
                    :row="row"
                    :employerColsEnabled="employerColsEnabled"
                >
                </applications-table-row>
            </tbody>
        </table>
    </div>
</template>

<script>
import ApplicationsTableRow from './applications-table-row';

export default {
        components: { ApplicationsTableRow },
        props: {
            employerColsEnabled: { type: Boolean, required: false, default: true },
            data: { type: Array, required: true },
        },
        data() {
            return {
                isBusy: false,
            };
        },
        methods: {
        },
    };
</script>
